document.addEventListener("DOMContentLoaded", function() {
    // Seleziona tutti i contenitori di slider
    const multiSliderContainers = document.querySelectorAll(".multi-slider-container");

    multiSliderContainers.forEach(container => {
        // Aggiungi event listener a tutti i bottoni di ogni slider
        container.querySelectorAll('.multi-slider-title').forEach((button, index) => {
            button.addEventListener('click', function() {
                setActiveSlider(container, index + 1);
                setActiveButton(container, button);
            });
        });
    });

    function setActiveSlider(container, activeSliderNumber) {
        // Logica per impostare lo slider attivo
        for (let i = 1; i <= 3; i++) {
            const collection = container.querySelector(`#multi-slider${i}-collection`);
            const blocks = container.querySelector(`#multi-slider${i}-blocks`);
            if (collection) {
                collection.classList.toggle('active-slider', i === activeSliderNumber);
                collection.classList.toggle('not-active-slider', i !== activeSliderNumber);
            }
            if (blocks) {
                blocks.classList.toggle('active-slider', i === activeSliderNumber);
                blocks.classList.toggle('not-active-slider', i !== activeSliderNumber);
            }
        }
    }

    function setActiveButton(container, activeButton) {
        // Rimuovi la classe 'active-button-slider' da tutti i bottoni
        container.querySelectorAll('.multi-slider-title').forEach(button => {
            button.classList.remove('active-button-slider');
        });
        // Aggiungi la classe 'active-button-slider' al bottone cliccato
        activeButton.classList.add('active-button-slider');
    }
});
